
export function isplausibleEmail(strinput) {    // 7 is length of a@b.org
  const fakeEmail = strinput?.length < 7 || strinput?.length > 70 || 
    strinput?.indexOf('@') === -1 || strinput?.indexOf('.') === -1;
  return !fakeEmail
}
export function isplausibleFactor(strIn) {
  if (!strIn)
    return ''
  const reNum = /^[+-.]?\d+(\.\d+)?$/
  if (!reNum.test(strIn))
    return "Must be numeric (or blank)"
  const num = Number(strIn)
  if (isNaN(num))
    return "Must be numeric"
  if (num <= 0)
    return "Must be greater than zero!"
  if (num > 1000000)
    return "Value too large"
  return ''
}
